import { render } from "./ClientsPage.vue?vue&type=template&id=80711e7e"
import script from "./ClientsPage.vue?vue&type=script&lang=js"
export * from "./ClientsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__